import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

// import $ from 'jquery'
import { deleteMetricSessionStorage } from '../../../features/metric/metricSlice'
import { appendModel } from '../../../features/site/siteSlice'
import { updateSite } from '../../utils/Organizations'
import { getTrafficSources } from '../../utils/Sites'
import usePrevious from '../../hooks/UsePrevious'

const INITIAL_STATE = {
    trafficSources: [],
    consumerSources: {},
    disableSubmit: false
}

function ConsumerSources(){
    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const trialMode = useSelector(state => state.session.trialMode)
    const model = useSelector(state => state.site.model)

    const prevModel = usePrevious(model)

    useEffect(() => {
        // try {
        //     $("#dtTbl").DataTable({
        //         destroy: true,
        //         order: [[1, 'asc']],
        //         searching: false,
        //         responsive: true,
        //         autoWidth: false,
        //         scrollCollapse: true,
        //         info: false,
        //         scrollX: 'auto',
        //         paging: true,
        //         lengthChange: false,
        //         pagingType: "simple",
        //         pageLength: 25,
        //         columnDefs: [{targets: [0, 1], orderable: false}]
        //     })
        // } catch(e){
        //     console.log(e)
        // }

        return () => {
            setState(INITIAL_STATE)
        }
    }, [])

    useEffect(() => {
        if((prevModel?.siteForm?.siteId !== model.siteForm?.siteId) && model.siteForm?.siteId){
            getTrafficSources(model.siteForm?.siteId).then(({response, error}) => {
                if(response && !response.errorMessage){
                    const consumerSources = {}
                    if(model.siteForm?.attr?.consumerSources){
                        model.siteForm?.attr?.consumerSources.forEach(function(value){
                            consumerSources[value] = true
                        })
                    }
                    setState(prev => ({
                        ...prev,
                        trafficSources: response.sort ? 
                            response?.sort((a,b) => a.toLowerCase() > b.toLowerCase() ? 1 : a.toLowerCase() < b.toLowerCase() ? -1 : 0) :
                        [],
                        consumerSources
                    }))
                } else {
                    setState(prev => ({
                        ...prev,
                        trafficSources: INITIAL_STATE.trafficSources
                    }))
                }
            })
        }
    }, [prevModel?.siteForm?.siteId, model.siteForm?.siteId])

    const saveConsumerSources = async() => {
        setState(prev => ({
            ...prev,
            disableSubmit: true
        }))
        let sForm = {
            ...model.sites[model.siteActiveIdx],
            attr: {
                ...model.sites[model.siteActiveIdx].attr,
                consumerSources: Object.keys(state.consumerSources).filter(k => state.consumerSources[k])
            }
        }

        await updateSite(model.siteForm?.siteId, null, {
            site: sForm
        })

        let all = [...model.all]
        let sites = [...model.sites]
        
        const allIdx = model.all.findIndex(s => s.siteId === sForm.siteId)

        all[allIdx] = {
            ...sForm
        }
        sites[model.siteActiveIdx] = {
            ...sForm
        }

        await dispatch(appendModel({
            all,
            sites,
            siteForm: sForm
        }))

        await dispatch(deleteMetricSessionStorage())

        toast.success("Update successful", {containerId: "defaultToastContainer"})

        setState(prev => ({
            ...prev,
            disableSubmit: false
        }))
    }

    const { trafficSources, consumerSources, disableSubmit } = state

    const inputDisabled = model.reseller && model.isAffiliate

    return <>
        <h3>Consumer Sources</h3><br />
        {!trialMode && <>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className="d-flex flex-row-reverse">
                <div>
                    <div className="mr-2">
                        <button className="btn btn-lg btn-primary" disabled={disableSubmit} onClick={() => saveConsumerSources()}>
                            <i class="fas fa-save"></i> Save
                        </button>
                    </div>
                </div>
            </div>}       
            <div class="table-responsive plr-10">
                <table className="table table-hover" id="dtTbl">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>Source</th>
                        </tr>
                    </thead>
                    <tbody>
                        {trafficSources.map(value => <tr>
                            <td><input type="checkbox" onChange={() => setState(prev => ({...prev, consumerSources: {...consumerSources, [value]: !consumerSources[value]}}))} checked={consumerSources[value] ? "checked" : ""} disabled={inputDisabled} /></td>
                            <td>{value}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        </>}
    </>
}

export default ConsumerSources